// Mis pagos del vendedor (`GET /commissions/me/payments`): el saldo del libro y sus depósitos.
import { useQuery } from '@tanstack/react-query';
import { commissionEngine } from '@/api/services/retail-commission/commissions.client';
import { useAuthStore } from '@/stores/authStore';

export function useMyPayments() {
    // El motor responde por el token: la clave lleva al usuario para no servirle a otro su caché.
    const userId = useAuthStore((state) => state.user?.cognitoSub ?? null);
    return useQuery({
        queryKey: ['sales', 'my-payments', userId],
        queryFn: () => commissionEngine.getMyPayments(),
        staleTime: 60_000,
    });
}
